<!-- 推荐学员列表 -->
<template>
  <div class="referral-con referral-con-table">
    <div>
      <h1>My referrals</h1>
      <template v-if="tableData.length">
        <div class="referral-table">
          <Table :columns="columnsData"
                 :data="tableData"></Table>
        </div>
        <!-- <div class="referral-page">
          <Page :total="totalItems"
                :page-size="pageSize"
                :current="currentPage"
                @on-change="handlePageChange"></Page>
        </div> -->
      </template>
      <zlr-empty v-else></zlr-empty>
    </div>
  </div>
</template>
<script>
// api
import { getRecommendList } from '@/api/recommend'
// components
import ZlrEmpty from '_c/empty/empty'
// mixins
// import mixinsPage from '@/view/mixins/page'
import { referralStatusMap } from '@/constant'
export default {
  name: 'referral-list',
  // mixins: [mixinsPage],
  components: {
    ZlrEmpty
  },
  props: {
    type: {
      type: String,
      validator (value) {
        return ['CLIENT', 'SCHOLARSHIP'].includes(value)
      }
    }
  },
  data () {
    return {
      columnsData: [
        {
          title: 'Mentee name',
          key: 'name',
          align: 'center',
          width: 165,
          fixed: 'left'
        },
        {
          title: 'Phone number',
          key: 'phone',
          width: 150,
          align: 'center'
        },
        {
          title: 'WeChat number',
          key: 'wechat',
          width: 150,
          align: 'center'
        },
        {
          title: 'Email',
          key: 'email',
          width: 150,
          align: 'center'
        },
        {
          title: 'University',
          key: 'univer',
          width: 175,
          align: 'center'
        },
        {
          title: 'Status',
          key: 'name',
          width: 165,
          align: 'center',
          fixed: 'right',
          render (h, params) {
            let status = params.row.status
            let title = ''
            if (status) {
              title = referralStatusMap.filter(item => item.value === status)[0]['title']
            }
            return h('div', title)
          }
        }
      ],
      tableData: []
    }
  },
  computed: {},
  mounted () {
    this.getPageList()
  },
  methods: {
    getPageList () {
      getRecommendList({
        type: this.type
      }).then(res => {
        this.tableData = res.data.model
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
